<template>
    <div class="scrollWrapper">
        <div class="card1" ref="card1"  :style="{transform: `translateY(${scroll1}px)`}">
            <div v-for="(it,ix) in list" :key="`scroll-user-${ix}`" class="userItem">
                <div class="userInfo">
                    <img :src="it.avatar" alt="头像" class="avatar">
                    <span class="name">{{it.name.length > 3 ? `${it.name.slice(0, 3)}...` : it.name}}</span>
                </div>
                <span class="content">已领取【{{it.item.length > 3 ? `${it.item.slice(0, 3)}...` : it.item}}】免费观影券</span>
            </div>
        </div>

        <div class="card2" ref="card2"  :style="{transform: `translateY(${scroll2}px)`}">
            <div v-for="(it,ix) in list" :key="`scroll-user2-${ix}`" class="userItem">
                <div class="userInfo">
                    <img :src="it.avatar" alt="头像" class="avatar">
                    <span class="name">{{it.name.length > 3 ? `${it.name.slice(0, 3)}...` : it.name}}</span>
                </div>
                <span class="content">已领取【{{it.item.length > 3 ? `${it.item.slice(0, 3)}...` : it.item}}】免费观影券</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ScrollUser",
        props: {
            list: {
                type: Array,
                default: ()=>[]
            }
        },
        data(){
            return {
                height: 0,
                scroll1: 0,
                scroll2: 0,
                timer: null
            }
        },
        mounted() {
            this.$nextTick(()=>{
                this.height = this.$refs.card1.offsetHeight
                this.scroll2 = this.height
                this.timer = setInterval(()=>{
                    this.scroll1 = this.scroll1 < -this.height ? 0 : this.scroll1-.5
                    this.scroll2 = this.scroll2 < 0 ? this.height : this.scroll2-.5
                }, 10)
            })
        },
        destroyed() {
            clearInterval(this.timer)
        }
    }
</script>

<style scoped lang="less">
    .scrollWrapper{
        width: 100%;
        position: relative;
        height: 100%;
        overflow: hidden;
        background-color: #fff;
        .userItem{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: .34rem 0;
            /*position: relative;*/
            .userInfo{
                display: flex;
                align-items: center;
                width: 2.8rem;
                .avatar{
                    width: 0.8rem;
                    height: 0.8rem;
                    display: inline-block;
                    border-radius: 50%;
                }
                .name{
                    font-size: 0.36rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: #376DF6;
                    line-height: 0.53rem;
                    padding: 0 0 0 .21rem;
                }
            }
            .content{
                font-size: 0.36rem;
                font-weight: 500;
                color: #333333;
                line-height: 0.53rem;
                flex: 1;
                /*white-space: nowrap;*/
            }
        }
        .card1{
            position: absolute;
            /*animation: 10s rowup linear infinite normal;*/
        }
        .card2{
            position: absolute;
            /*animation: 10s rowup2 linear infinite normal;*/
        }
        @keyframes rowup {
            0% {transform: translateY(0);}
            100% {transform: translateY(-26.5rem);}
        }
        @keyframes rowup2 {
            0% {
                transform: translateY(26.5rem);
            }
            100% {
                transform: translateY(0);
            }
        }
    }
</style>
